/** @module SiteAdmin/CommentsRenderer */
define([
	"dojo/_base/declare",
	"underscore",
	"csi/action/Popup",
	"csi/heading/RefContainer",
	"csi/html",
	"csi/locale",
	"csi/state/rootStore",
	"csi/types",
	"csi/xml"
], function(declare, _, Popup, RefContainer, html, locale, {sessionStore}, types, xml) {

	var COMMENT = "Comment";
	var _action;

	/**
	 * Create popup action and add to view
	 * @param {Context} ctx
	 * @return {Action}
	 */
	function _getPopupAction(ctx) {
		if (!_action) {
			_action = new Popup();
			_action.m_id = "PopupComments";
			_action.classController = "SiteAdmin.CommentsPopupController";
		}

		ctx.defView._addViewAction(_action);

		return _action;
	}

	return declare(RefContainer, {
		bSort: false,

		/**
		 * @override
		 * Force large if at least 1 comment
		 */
		canBeLarge: function(ctx, h) {
			var v = ctx.getNodeAttributeValue(h.m_id);
			return (v && (v.length > 1)) ? 2 : 0;
		},

		/**
		 * @override
		 * Allow sorting by most recent comment date
		 */
		getQuerySpec: function(ctx, h, spec) {
			var ep = spec.getExtendedPath().clone();
			ep.addRelationStep(h.m_id, COMMENT, 0);
			ep.addRelationStep("LastPost", COMMENT);
			var path = ep.getQueryPath();

			spec.sortQuerySpec = {
				id: "Date",
				path: path,
				ren: this,
				type: xml.ATTR_TIME
			};

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * Add content and actions to tooltip - if comments attribute cannot be reached, the nodes will be null
		 * and then do not display the View Comments action (if the posts array is just empty the nodes will be [])
		 */
		toTooltip: function(ctx, h, tooltip) {
			var node = ctx.getNode();
			if (node && node.$Type == COMMENT) {
				var lastPost = ctx.cache.getNode(node.LastPost) || node;
				if (lastPost.Comment) {
					var div = html.create("div", {"class": html.CSS_RICH_TEXT});
					html.richText(lastPost.Comment, div);
					tooltip.addContent(div);
				}
			} else if (!this.getReferencedNodes(ctx, h)) {
				return;
			}

			// add action to popup comments view
			tooltip.addAction(this._mixinTooltipAction(_getPopupAction(ctx), h));
		},

		/**
		 * @override
		 * Add special CSS for comments 
		 */
		_getCSS: function(type, format) {
			return this.inherited(arguments) + " attrComments";
		},

		/**
		 * @override
		 * Cell is not editable
		 */
		_getRenderAction: function(ctx, h) {
			return null;
		},

		/**
		 * @override
		 * Override default comma
		 */
		_getSeparator: function(h) {
			return "";
		},

		/**
		 * @override
		 * Custom render code for comments to include author, date and attachment icon if necessary
		 */
		_renderNode: function(ctx, h, refNode, node) {
			var lastPost = ctx.cache.getNode(node.LastPost);
			var date = types.formatTime(lastPost.Date, sessionStore.print ? types.FORMAT_DATETIME : types.FORMAT_DIFF);
			var user = ctx.cache.getNode(lastPost.Author).$Name;

			var div = html.create("div", {
				innerText: locale.resource("CommentHeader", [date, user]) + (ctx.bPrint ? node.$Name : "")
			}, refNode);

			if (!ctx.bPrint) {
				var anchor = html.create("a", {
					"class": html.CSS_BROWSE,
					innerText: node.$Name
				}, div);

				var action = _getPopupAction(ctx);
				html.setElementAction(anchor, action.m_id);
				html.setElementContext(anchor, node.$URL);
			}

			if (!_.isEmpty(lastPost.Images) || !_.isEmpty(lastPost.Files)) {
				html.create("span", {
					"class": "csiActionIcon material-icons",
					innerText: "attach_file"
				}, div);
			}

			return div;
		}
	});
});